/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IConfigureRowScope extends ng.IScope {
        formName: string;
        isEditMode: boolean;
        showSlider: boolean;
        moveStepAvailable: boolean;
        description: string;
        isMultiStep: boolean;
        showCustomCode: boolean;
        formConfiguration: Wars.Domain.Model.Form;
        apiActions: Wars.Domain.Model.ApiAction[];
        filteredApiActions: Wars.Domain.Model.ApiAction[];
        processTypes: Wars.Domain.Model.ProcessType[];
        selectedApiAction: Wars.Domain.Model.ApiAction;
        save: any;
        processTypeChanged: any;
        toggleShowFormSchema(): void;
        selectApiAction: any;
        showFormSchema: boolean;
    }

    export class ConfigureRow implements IDirective {


        public link($scope: IConfigureRowScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/inputForm/configureRow.html';
        public restrict: string = 'E';
        public scope: any = {
            formName: "=",
            isEditMode: "=",
            showSlider: "=",
            moveStepAvailable: '=',
            description: '=',
            isMultiStep: "=",
            showCustomCode: "=",
            formConfiguration: "="
        }
        public controller = ["$scope", "apiActionService", ConfigureRowController];
        public controllerAs = "controller";

    }

    export class ConfigureRowController {
        constructor(private $scope: IConfigureRowScope, private apiActionService: services.ApiActionService) {

            this.apiActionService.getApiConfigurations().then(r => {
                $scope.apiActions = r;

                $scope.processTypes = Enumerable.from($scope.apiActions).select(a => a.processConfiguration.myProcessType).distinct().toArray();

                this.setFilteredApiActions();
            });

            $scope.save = () => this.save();
            $scope.selectApiAction = () => this.selectApiAction();
            $scope.processTypeChanged = () => this.processTypeChanged();
            $scope.toggleShowFormSchema = () => this.toggleShowFormSchema();
            $scope.showFormSchema = false;
        }

        public processTypeChanged() {
            this.setFilteredApiActions();
            this.$scope.formConfiguration.defaultFormValueApiActionUniqueId = null;

            this.save();
        }

        public selectApiAction() {
            this.setSelectedApiAction();

            this.$scope.formConfiguration.mySteps.forEach(s => {
                s.formSections.forEach(fs => {
                    fs.fields.forEach(field => {
                        field.defaultSchemaPropertyUniqueId = null;
                    });
                });
            });

            this.save();
        }

        private toggleShowFormSchema(): void {
            this.$scope.showFormSchema = !this.$scope.showFormSchema;
        }

        private save() {
            this.apiActionService.saveAllChanges();
        }

        private setFilteredApiActions() {
            this.$scope.filteredApiActions = Enumerable.from(this.$scope.apiActions).where(a => a.processConfiguration.processType_id == this.$scope.formConfiguration.apiActionProcessType_id)
                .distinct(a => a.uniqueId).toArray();

            this.setSelectedApiAction()
        }

        private setSelectedApiAction() {
            this.$scope.selectedApiAction = Enumerable.from(this.$scope.filteredApiActions).singleOrDefault(a => a.uniqueId == this.$scope.formConfiguration.defaultFormValueApiActionUniqueId);
        }
    }
}


warsApp.registerDirective('ConfigureRow', []);